export default __webpack_public_path__ + "static/media/veransa-300w-min.6830c34c.jpeg";